import {
  DropdownWithButton,
  DropdownListItem,
  DropdownList,
  ButtonComponentProps,
  Icon
} from '@hm/fundamental'
import {buildFeatureUrl} from '@hproduce/suite-core'
import {mdiMenuDown, mdiMenuUp} from '@mdi/js'
import {forwardRef} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

import {FeatureMenuEntry} from '../../../api/types/featuresMenu'

import {useHierarchyIdFromURL} from './PlantSelectButton/useHierarchyIdFromUrl'

interface BreadcrumbSiblingFeatureDropdownProps {
  features: FeatureMenuEntry[]
}

export const BreadcrumbSiblingFeatureDropdown = ({
  features
}: BreadcrumbSiblingFeatureDropdownProps) => {
  const navigate = useNavigate()
  const {t} = useTranslation()
  const [hierarchyId] = useHierarchyIdFromURL()

  const dropdownComponent = forwardRef<HTMLDivElement, ButtonComponentProps>(
    ({isDropdownOpen, onClick}, ref) => (
      <div ref={ref} onClick={onClick} className="flex cursor-pointer text-foreground">
        <Icon path={isDropdownOpen ? mdiMenuUp : mdiMenuDown} size="xlarge" />
      </div>
    )
  )

  return (
    <div data-test-id="feature_breadcrumb_dropdown">
      <DropdownWithButton component={dropdownComponent}>
        <DropdownList>
          {features.map((sibling) => (
            <DropdownListItem
              data-cy={`feature_breadcrumb_dropdown_list_item_${sibling.name}`}
              onClick={() => {
                void navigate(buildFeatureUrl(sibling.name, hierarchyId))
              }}
              key={sibling.name}
              title={t(`suite.featureName.${sibling.name}`, {defaultValue: sibling.name})}
            />
          ))}
        </DropdownList>
      </DropdownWithButton>
    </div>
  )
}
